<template>
  <el-dialog
      v-model="dialogVisible"
      :title="t('edit')"
      width="500"
      :before-close="handleClose"
  >
    <div>
      <el-input v-model="serialNumber"></el-input>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">{{t('cancel')}}</el-button>
        <el-button type="primary" @click="submit">
          {{t('confirm')}}
        </el-button>
      </div>
    </template>
  </el-dialog>
  <div class="flex gap-2 items-center">
    <div>{{ updatedSerialNumber }}</div>
    <div @click="() => {dialogVisible = true}"
         class="cursor-pointer text-gray-400 hover:text-gray-800">
      <font-awesome-icon icon="edit"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from 'vue'
import {useHTTP} from "@/plugins/http";
import {ElMessage, ElLoading} from "element-plus";
import ItemSerial from "@/models/inventory/ItemSerial";
import {useI18n} from "vue-i18n";

const props = defineProps(['serial'])

const http = useHTTP();

const messages = {
  en: {
    edit: 'Edit item serial',
    pleaseWait: 'Please wait...',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  ar: {
    pleaseWait: 'يرجى الانتظار...',
    edit: 'تعديل الرقم التسلسلي',
    confirm: 'تعديل',
    cancel: 'الغاء'
  }
}
const { t } = useI18n({ messages, useScope: 'global' })

const dialogVisible = ref(false)
const isLoading = ref(false)
const serialNumber = ref("")
const updatedSerialNumber = ref("")


onMounted(() => {
  serialNumber.value = props.serial ? props.serial.number: "";
  updatedSerialNumber.value = props.serial ? props.serial.number: "";
})

const handleClose = (done: () => void) => {
  if (!isLoading.value) {
    done();
  }
}

async function submit() {
  isLoading.value = true;
  const loading = ElLoading.service({
    lock: true,
    target: document.querySelector(".el-dialog"),
    text: t('pleaseWait'),
  })

  try {
    const data = JSON.parse(JSON.stringify(props.serial))
    data.number = serialNumber.value
    const resp = await http.put<any>(`${ItemSerial.ENDPOINT}/${props.serial.id}`, data)
    updatedSerialNumber.value = serialNumber.value;
    dialogVisible.value = false
    ElMessage({
      message: t('actions.saveChangesSuccess'),
      type: 'success'
    })
  } catch (error) {
      ElMessage({
        message: error.body,
        type: 'error'
      })
  }
  loading.close()
  isLoading.value = false;
}
</script>

<style scoped>

</style>
